import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CameraIcon(props: IconProps) {
    return <Icon {...props} iconKey={"camera"}/>
}
